const traverseDate = (values, type) => {
    if (values === null || values === '') {
        return '';
    }
    values = values.split(" ")[0];
    let res = '';
    switch(type) {
        case 'day': res = values.split('-')[2]; break;
        case 'month': res = values.split('-')[1]; break;
        case 'year': res = values.split('-')[0]; break;
        case 'date': res = values;
    }
    return res;
}
export { traverseDate }